@let siteData = appState().siteData;

<header
  class="flex-row-center gap-3 p-3 drop-shadow-md"
  [style.background-color]="siteData?.knowledgeBase?.headerColor ?? '#ffffff'"
>
  @let logo = siteData?.knowledgeBase?.logo;
  @let siteName = siteData?.knowledgeBase?.name || 'Help';

  <div class="cursor-pointer" [routerLink]="routeNavigationService.homeUrl()">
    @if (logo) {
      <img [ngSrc]="logo.url" [style.height.px]="40" [height]="40" [width]="80" alt="siteName" class="w-auto" [priority]="true">
    } @else {
      <h1>{{ siteName }}</h1>
    }
  </div>

  <div class="flex-1">
    <div class="hidden md:flex flex-row justify-center">
      @if (!appState().isHomePageOpen) {
        <div class="w-1/2">
          <app-article-search-bar />
        </div>
      }
    </div>
  </div>

  <div class="flex-row-center justify-end">
    @if (!appState().isHomePageOpen) {
      <div class="md:hidden">
        <button class="md:hidden" mat-button (click)="openSearch()">
          <fa-icon [icon]="faSearch" />
        </button>
      </div>

      <div class="md:hidden">
        <button class="md:hidden" mat-button (click)="openNav()">
          <fa-icon [icon]="faBars" />
        </button>
      </div>
    }

    <div class="hidden md:block">
      <app-language-selector />
    </div>
  </div>
</header>
